export default __webpack_public_path__ + "static/media/submitBackgroundXL.a9ef3552.svg";